export default __webpack_public_path__ + "static/media/medicine.0a0c79a6.png";